<div class="container">
  <div class="card">
    <div class="card-body">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let user of users">
            <td>{{ user.firstName }}</td>
            <td>{{ user.lastName }}</td>
            <td>{{ user.email }}</td>
            <td>{{ (user.fheProgress | percentage) || 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
